import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-refresh-token',
    templateUrl: './dialog-refresh-token.component.html',
    styleUrls: ['./dialog-refresh-token.component.scss'],
    standalone: false
})
export class DialogRefreshTokenComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DialogRefreshTokenComponent>) {
  }

  ngOnInit(): void {
  }

  closeDialog() {
    this.dialogRef.close(false);
  }
}
